export default interface UserModel {
  id: string;
  fullname?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  icon?: string;
  passcode?: string;
  createdAt?: Date | string;
  lastSignIn?: Date | string;
}

export enum UserRole {
  SuperAdmin = 'super-admin',
  Admin = 'admin',
  ProductManager = 'products',
  ClientManager = 'clients',
  OperationalManager = 'operations',
  WarehouseManager = 'warehouse',
  Financial = 'finance',
  Picker = 'picker',
  Packer = 'packer',
  Supplier = 'supplier',
  Client = 'client'
}
